import { CategoricalPalette, WhpClass } from './types';

// Canonical 5-class palette for Wildfire Hazard Potential.
// Kept in sync manually with scripts/generate-whp-data.py, which renders
// the on-map raster PNGs using the same colors so the left-panel bar
// chart acts as the legend for the overlay.
export const WHP_PALETTE: CategoricalPalette<WhpClass> = {
  colors: {
    very_low:  '#1A9850',
    low:       '#91CF60',
    moderate:  '#FEE08B',
    high:      '#FC8D59',
    very_high: '#D73027',
  },
  labels: {
    very_low:  'Very Low',
    low:       'Low',
    moderate:  'Moderate',
    high:      'High',
    very_high: 'Very High',
  },
  order: ['very_low', 'low', 'moderate', 'high', 'very_high'],
};
